import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from 'js/components/Button'
import Checkbox from 'js/components/Checkbox/Checkbox'
import Flexer from 'js/components/Flexer/Flexer'
import Popover from 'js/components/Popover'
import Spacer from 'js/components/Spacer/Spacer'
import Text from 'js/components/Text/Text'
import { usePluginsWithTemplateOptions } from 'js/group/AddEditForm/hooks/usePlugins'

const PluginsOption = ({
    option: { value, label },
    plugins,
    setPlugins,
    menu,
    setMenu,
}) => {
    const { t } = useTranslation()

    const [showAddToMenuPrompt, setShowAddToMenuPrompt] = useState(false)

    const pluginsWithTemplateOptions = usePluginsWithTemplateOptions()

    const optionHasPageTemplate = pluginsWithTemplateOptions.find(
        (el) => el.value === value,
    )
    const optionExistsInMenu = menu.find((el) => el.id === value)

    const handleChange = ({ target: { checked } }) => {
        if (optionHasPageTemplate) {
            if (
                (optionExistsInMenu && !checked) ||
                (!optionExistsInMenu && checked)
            ) {
                setShowAddToMenuPrompt(true)
            }
        }

        if (checked) {
            setPlugins([...plugins, value])
        } else {
            setPlugins((prev) => prev.filter((plugin) => plugin !== value))
        }
    }

    const handleAddToMenu = () => {
        if (optionExistsInMenu) {
            setMenu((prev) => prev.filter((el) => el.id !== value))
        } else {
            setMenu([
                ...menu,
                {
                    id: value,
                    type: 'plugin',
                },
            ])
        }

        setShowAddToMenuPrompt(false)
    }

    const message = optionExistsInMenu ? (
        <span>
            {t('entity-group.remove-type-from-navigation-prompt')}
            {value === 'files' && (
                <>
                    <br />
                    {t('entity-group.remove-type-from-navigation-prompt-files')}
                </>
            )}
        </span>
    ) : (
        t('entity-group.add-type-to-navigation-prompt')
    )

    return (
        <Popover
            open={showAddToMenuPrompt}
            side="top"
            align="start"
            triggerIsNotButton={true}
            content={
                <Spacer spacing="tiny" style={{ padding: '8px 12px 12px' }}>
                    <Text size="small" textAlign="center">
                        {message}
                    </Text>
                    <Flexer>
                        <Button
                            size="small"
                            variant="tertiary"
                            onClick={() => {
                                setShowAddToMenuPrompt(false)
                            }}
                        >
                            {t('action.no-skip')}
                        </Button>
                        <Button
                            size="small"
                            variant="primary"
                            onClick={handleAddToMenu}
                        >
                            {t('action.yes-confirm')}
                        </Button>
                    </Flexer>
                </Spacer>
            }
        >
            <Checkbox
                key={`plugins-${value}`}
                name={`plugins-${value}`}
                onChange={handleChange}
                label={label}
                checked={plugins.includes(value)}
                size="small"
            />
        </Popover>
    )
}

export default PluginsOption
